// @flow
/** @jsx jsx */
import { jsx } from '@emotion/core';

import { type CurrencyRulesetItem } from '@zapier/payment/src/hooks/useCurrencyRuleset';
import PaymentMethodImage from '@zapier/payment/src/components/PaymentMethodImage';
import { type CreditCardBrandCode } from '@zapier/payment/src/types';

type Props = {
  /** Show small version of images */
  isSmall?: boolean,
  methods: Array<CurrencyRulesetItem>,
  /** All other payment method icons will be greyed out */
  selectedMethod?: ?CreditCardBrandCode,
};

const wrapperCss = {
  'span + span, span + svg': {
    marginLeft: 15,
  },
};

const PaymentMethodImageStrip = ({ isSmall = false, methods = [] }: Props) => {
  const images = methods.map(method => {
    return (
      <PaymentMethodImage
        imageType={method.submethod}
        isSmall={isSmall}
        key={method.submethod}
      />
    );
  });

  return <div css={wrapperCss}>{images}</div>;
};

export default PaymentMethodImageStrip;
